import rest from './rest';
import store from '@/store';

async function load() {
  const user = await rest.get('/user');
  store.set('user', user);
}

async function update(data) {
  if (data.password == "") {
    delete data.password;
  }
  const user = await rest.put('/user', data);
  store.set('user', user);
}

async function rekey() {
  const key = await rest.post('/user/rekey');
  store.set('user', {...store.get('user'), ...key});
}

export default {
  load,
  update,
  rekey
};
